export const formatProductTitle = (productTitle: string, variantTitle?: string) =>
  variantTitle && variantTitle !== '1' ? `${productTitle} (${variantTitle})` : productTitle;
